module.exports = __webpack_public_path__ + "img/logo-world-bank.809996d3.jpg";